import React from 'react';
import ReactJson, { CollapsedFieldProps } from 'react-json-view';

const jsonTheme = {
	base00: 'white',
	base01: 'red',
	base02: 'white', //indent lines
	base03: 'white',
	base04: '#9b53bd',
	base05: 'white',
	base06: 'black',
	base07: '#0451A5', //keys
	base08: 'black',
	base09: '#A31515', //strings
	base0A: '#C4A015',
	base0B: '#098658', //Some integers
	base0C: '#A31515',
	base0D: '#9b53bd', //Expand/Collapse arrows
	base0E: '#9b53bd', //Array expand arrows
	base0F: '#098658' // Other integers
};

const JsonDisplay: React.FC<JsonDisplayProps> = (props) => {
	const { data, groupArraysAfterLength, shouldCollapse } = props;
	return (
		<ReactJson
			src={data}
			style={{ paddingTop: '0.5vh', maxHeight: 'fit-content', overflowY: 'auto', overflowX: 'auto' }}
			displayDataTypes={false}
			displayArrayKey={false}
			groupArraysAfterLength={groupArraysAfterLength ?? 50}
			displayObjectSize={false}
			enableClipboard={false}
			theme={jsonTheme}
			indentWidth={4}
			shouldCollapse={shouldCollapse ?? false}
		/>
	);
};
type JsonDisplayProps = { data: object; groupArraysAfterLength?: number; shouldCollapse?: (field: CollapsedFieldProps) => boolean };
export default JsonDisplay;
